export const Footer = (props) => {
  
  return (
    <div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; 2022 AVFREEX24 Design by{' '}
            <a href='https://pnckdevapp.com' rel='nofollow'>
              CHANGYED
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
